import { CheckboxProps, Checkbox as CssModulesCheckbox, CheckboxState as CssModulesCheckboxState } from '@sunwebgroup/uds-ui/checkbox'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/checkbox' instead.
 */
const Checkbox = Object.assign(
  styled(CssModulesCheckbox)<CheckboxProps>``,
  { displayName: 'Checkbox' },
)

/**
 * @deprecated This type alias is deprecated, kept only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/checkbox' instead.
 */
export type CheckboxState = CssModulesCheckboxState

export default Checkbox
